import moment from 'moment-timezone';

import { dateFormat, dateTimeFormatWithTimezone } from '../../constants/apiDateFormat';

/**
 * Get start of day (00:00:00.000) in specified timezone
 */
export const getStartOfDayInTz = (date: string, timezone: string): string =>
  moment.tz(date, dateFormat, timezone).startOf('day').format(dateTimeFormatWithTimezone);
